<template>
  <div id="realTimeMap">
    <v-container fluid class="overrideContainer">
      <v-row>
        <v-col md="9" cols="12" lg="10" class="overrideCol" order="2">
          <v-responsive :height="mapSize.height" width="auto">
            <div class="mapWrapper">
              <GoogleRetroactivePoiEnteranceComponent v-if="mapType == 1" />
              <LeafletRetroactivePoiEnteranceComponent v-if="mapType == 0" />
            </div>
          </v-responsive>
        </v-col>
        <v-col cols="12" md="3" lg="2" :order="mobileBereakPoint ? 1 : 3">
          <RetroactivePoiContainer />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import mapMixin from '../mapMixin.js'
export default {
  name: 'BaseRetroactivePoiEnteranceComponent',
  mixins: [mapMixin],
  data() {
    return {
      mobileDisplayRatio: 1
    }
  },
  components: {
    GoogleRetroactivePoiEnteranceComponent: () =>
      import('../retroactivePoiEnterance/GoogleRetroactivePoiEnteranceComponent'),
    LeafletRetroactivePoiEnteranceComponent: () =>
      import('../retroactivePoiEnterance/LeafletRetroactivePoiEnteranceComponent'),
    RetroactivePoiContainer: () =>
      import('@/components/map/retroactivePoi/RetroactivePoiContainer')
  },
  computed: {
    mobileBereakPoint() {
      //sm and down
      return this.$vuetify.breakpoint.smAndDown
    },
    mapSize: function() {
      const displayHeight = this.$vuetify.breakpoint.height
      if (!this.mobileBereakPoint) {
        return {
          height: 'auto',
          width: 'auto'
        }
      } else {
        return {
          height: displayHeight / this.mobileDisplayRatio,
          width: 'auto'
        }
      }
    }
  }
}
</script>

<style scoped>
.overrideContainer {
  padding: 0px !important;
}

.overrideCol {
  padding: 0px !important;
}
</style>
